export default "__VITE_ASSET__lAXPoPne__"